export default __webpack_public_path__ + "static/banner-unexpected-wedding-costs-64804d4bf2271cf51563b9452af12555.jpg";